<template>
  <div>
    <Header
        :headerTitle="$t('m.provinceList.title')"
        :hasBackBtn="false"
    ></Header>
    <div class="main-container">
      <b-container>
        <b-row>
          <b-col cols="3" v-for="(pro,index) in province" :key="pro.id">
            <div
                class="province-name"
                :class="pro.name == indexs?'active':'normal'"
                @click="selectProvince(index)"
            >{{pro.name}}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>

<script>
  import {provinceList} from "../api/parking.js";

  export default {
    name: "provinceList",
    data() {
      return {
        province: [],
        indexs: 0,
        message: "", //提示信息
        tipShow: "0", //是否提示
        tipType: "" //提示类型
      };
    },
    methods: {
      selectProvince(index) {
        var provinceName = this.province[index].name;
        eventBus.$emit("provinceName", provinceName);
        this.$router.back(-1);
      },
      fetchProvinceList() {
        provinceList().then(response => {
          if (response.data.status == 200) {
            this.province = response.data.result;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        });
      }
    },
    created() {
      this.fetchProvinceList();
      let indexs = localStorage.getItem("provinceName");
      if (indexs) {
        this.indexs = indexs;
      } else {
        this.indexs = "京";
      }
    }
  };
</script>

<style scoped>
  ul {
    list-style: none;
  }

  .container .row {
    padding: 0;
  }

  .container .row .col-3 {
    padding: 10px;
  }

  .container .row .province-name {
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    font-family: HiraginoSansGB-W6;
    font-size: 18px;
    font-weight: 600;
    padding: 10px;
  }

  .normal {
    border-color: #e5e5e5 !important;
    color: #8e8e8e;
  }

  .active {
    border-color: #008eb0 !important;
    color: #008eb0;
  }
</style>
